import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false;

import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin);

import VueI18n from 'vue-i18n'
Vue.use(VueI18n);

import store from "@/store";
import router from "@/./router";
import PageRoyaumeModel from "./PageRoyaumeModel";
const axios = require('axios').default;

import IdleVue from 'idle-vue'
const eventsHub = new Vue()
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 3*60*1000
})

let start=function(pages){
    for(let p of pages){
        console.log(p);
        PageRoyaumeModel.all.push(new PageRoyaumeModel(p));
    }
    store.state.pages=PageRoyaumeModel.all;
    //go !
    window.toto=new Vue({
        router,
        store,
        render: h => h(App),
    }).$mount('#app');
}


axios.get('pages.json', {})
    .then(function (response) {
        start(response.data);
    })
    .catch(function (error) {
      console.error("impossible de charger le json via ajax",error);
      start(require("../public/pages.json"))
    })
    .then(function () {
      // always executed
    });


